import React, { memo } from "react";
import { useLocation } from "react-router-dom";

function FormSteps() {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <ul className="step">
      <li
        className={
          currentPath.includes("form") &&
          !currentPath.includes("thanks") &&
          !currentPath.includes("confirm")
            ? "isCurrent"
            : ""
        }
      >
        <b>フォームの入力</b>
        <span></span>
      </li>
      <li className={currentPath.includes("confirm") ? "isCurrent" : ""}>
        <b>入力確認</b>
        <span></span>
      </li>
      <li className={currentPath.includes("thanks") ? "isCurrent" : ""}>
        <b>送信完了</b>
        <span></span>
      </li>
    </ul>
  );
}

export default memo(FormSteps);
